import { useQuery } from '@tanstack/react-query';
import {
	fetchPendingUserTypeRequests,
	PendingUserTypeRequest,
} from 'Services/Api/_HumanWritten/UserTypeRequestService';
import { userTypeRequestKeys } from './userTypeRequestKeys';

/**
 * The pending user type requests for a user — powers the "Requested" state on the request
 * button. userId omitted = the logged-in user.
 */
export const usePendingUserTypeRequests = (userId?: string, enabled = true) => {
	return useQuery<PendingUserTypeRequest[], Error>({
		queryKey: userTypeRequestKeys.pending(userId),
		queryFn: () => fetchPendingUserTypeRequests(userId),
		enabled,
	});
};
